import { FC } from 'react';
import { Box, Typography } from '@mui/material';
// components
import { AuthLayoutContainer } from '../../theme/styleComponent';
// interfaces
import { AuthLayoutProps } from '../../interfaces';

export const LayoutContainer: FC<AuthLayoutProps> = ({
  icon,
  title,
  mb = 1,
  children,
  subTitle,
  layoutContainer,
  maxWidth = '480px',
  paddingX = 'initial',
  lineHeight = 'initial',
}) => {
  return (
    <AuthLayoutContainer sx={layoutContainer}>
      <Box width="100%" maxWidth={maxWidth} paddingX={paddingX} px={{ xs: 0 }}>
        {icon && (
          <Box textAlign="center" mb={5}>
            {icon}
          </Box>
        )}

        <Box>
          <Box pb={5} textAlign="center">
            <Typography variant="h5" mb={mb}>
              {title}
            </Typography>

            <Box>
              {subTitle && (
                <Typography variant="subtitle1" component="p" lineHeight={lineHeight}>
                  {subTitle}
                </Typography>
              )}
            </Box>
          </Box>

          {children}
        </Box>
      </Box>
    </AuthLayoutContainer>
  );
};
